import {h} from 'preact';
import {CalculatorOption} from '../types';
import {Option} from './Option';

type OptionsTableProps = {
  items: CalculatorOption[];
}

// TODO: delete after inmplementing real logic
// const mockOptions: CalculatorOption[] = data.business.kits[2].options;

function OptionsTable({items}: OptionsTableProps) {
  return (
    <>
      <p>Дополнительные опции</p>
      <form className="options__table">
        {
          items.map(
            (option, i) => (
            <Option item={option} id={i} />
          ))
        }
      </form>
    </>
  )
}

export {OptionsTable};

